import React, { useEffect, useState } from "react";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Button from "../../components/Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { CardContainer, OuterCardContainer } from "../../components/Card/CardContainer";
import { Col, Divider, Form, Modal, Row } from "antd";
import Text from "../../components/Text/Text";
import dayjs from "dayjs";
import { zoneDatasource } from "../../datasource/ZoneDatasource";
import {
  createProductQuota,
  deleteQuotaProductQuota,
  getProductQuotaById,
  getProductQuotaProduct,
  getQuotaTotalGroup,
  updateProductQuota,
  updateProductQuotaGroup,
  updateQuotaGroupForDuplicate,
  updateShopStatus,
} from "../../datasource/ProductQuotaDatasource";
import StepAntd from "../../components/StepAntd/StepAntd";
import { getStepItems } from "../../utility/StepQuota";
import { getShopGroup } from "../../datasource/ShopGroupDatasoure";
import StepOneDup from "./StepDup/StepOneDup";
import { StepTwoDup } from "./StepDup/StepTwoDup";
import StepThreeDup from "./StepDup/StepThreeDup";
import ConfirmModal from "../../components/Modal/ConfirmModal";

export const CreateProductQuotaDup: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company, firstname, lastname, role } = userProfile;
  const location = useLocation();
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const quotaId = pathSplit[3];
  const isEditing = pathSplit[2] === "edit";
  const isDuplicate = pathSplit[2] === "duplicate";
  const [loading, setLoading] = useState(false);
  const [shopGroupData, setShopGroupData] = useState<any[]>([]);
  const [zoneList, setZoneList] = useState<any[]>([]);
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [confirmModal, setConfirmModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<{
    success: boolean;
    step: number;
    message: string;
  } | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [loadingStep, setLoadingStep] = useState(true);

  useEffect(() => {
    setLoadingStep(true);
    setLoading(true);
    if (isEditing && quotaId) {
      setLoading(true);
      form1.setFieldsValue({
        ...location.state?.form1,
        startDate: dayjs(location.state.form1.startDate),
        endDate: dayjs(location.state.form1.endDate),
        startTime: dayjs(location.state.form1.startTime),
        endTime: dayjs(location.state.form1.endTime),
      });
      form2.setFieldsValue(location.state?.form2);
      setLoading(false);
      setLoadingStep(false);
    } else if (isDuplicate && quotaId) {
      fetchData();
    }
    setLoading(false);
    setLoadingStep(false);
    fetchShopGroupList();
    fetchZoneList();
  }, [form1, form2, location.state]);

  const fetchData = async () => {
    setLoading(true);
    await getProductQuotaById(quotaId).then((item) => {
      const res = item.data;
      form1.setFieldsValue({
        ...res,
        quotaName: res.quotaName + "_copy",
        startDate: null,
        endDate: null,
        startTime: dayjs("00:00", "HH:mm"),
        endTime: dayjs("23:59", "HH:mm"),
        limitQuantityOrder: res?.conditionQuota?.limitQuantityOrder,
        limitOrderDay: res?.conditionQuota?.limitOrderDay,
        limitOrderPerDayType: res?.conditionQuota?.limitOrderDayCondition?.allShop
          ? "allShop"
          : res?.conditionQuota?.limitOrderDayCondition?.perShop
            ? "perShop"
            : undefined,
        allShop: res?.conditionQuota?.limitOrderDayCondition?.allShop,
        perShop: res?.conditionQuota?.limitOrderDayCondition?.perShop,
        countOrder: res?.conditionQuota?.limitOrderDayCondition?.orderAmount,
        quotaTotalAmount: undefined,
      });
      form2.setFieldValue(
        "summary",
        res?.quotaType === "QUOTA_TOTAL" ? [item?.summary] : item?.summary,
      );
    });
    if (form1.getFieldValue("quotaType") !== "QUOTA_INDIVIDUAL") {
      await getQuotaTotalGroup(quotaId).then((res) => {
        const getValue = res.productQuotaGroup;
        if (form1.getFieldValue("quotaType") === "QUOTA_GROUP") {
          const mapValueForm2 = getValue.map((item: any, groupIndex: number) => {
            const mapProduct = item.productQuota.map((pq: any) => {
              form2.setFieldValue(`limitQty-${pq.product.productId}`, pq.orderLimit);
              form2.setFieldValue(`specialPrice-${pq.product.productId}`, pq.discount);
              return {
                createdAt: pq.createdAt,
                discount: pq.discount,
                notDelete: pq.notDelete,
                orderLimit: pq.orderLimit,
                productQuotaGroupId: pq.productQuotaGroupId,
                productQuotaId: pq.productQuotaId,
                quotaId: pq.quotaId,
                updatedAt: pq.updatedAt,
                productId: pq.productId,
                commonName: pq.product.commonName,
                marketPrice: pq.product.marketPrice,
                packSize: pq.product.packSize,
                productCodeNAV: pq.product.productCodeNAV,
                productGroup: pq.product.productGroup,
                productImage: pq.product.productImage,
                productName: pq.product.productName,
                saleUOM: pq.product.saleUOM,
                saleUOMTH: pq.product.saleUOMTH,
              };
            });
            item.shopTotalQuota.map((sq: any) => {
              form2.setFieldValue(
                `orderPerDay-${sq.customerCompanyId}-${item.groupNo}`,
                sq.orderPerDay,
              );
              form2.setFieldValue(
                `quotaReceive-${sq.customerCompanyId}-${item.groupNo}`,
                sq.quotaReceive,
              );
            });
            form2.setFieldsValue({
              quotaId: undefined,
              [`productQuotaGroupId-${item.groupNo}`]: undefined,
            });
            return {
              groupNo: item.groupNo,
              productList: mapProduct,
              storeList: item.shopTotalQuota.map((sq: any) => {
                return {
                  ...sq,
                  productQuotaGroupId: undefined,
                  shopTotalQuotaId: undefined,
                  quotaId: undefined,
                  oldIsActive: sq.isActive,
                  isActive: true,
                  isChecked: false,
                };
              }),
            };
          });
          form2.setFieldsValue({ products: mapValueForm2, summary: res.summary });
        } else if (form1.getFieldValue("quotaType") === "QUOTA_TOTAL") {
          getValue.map((item: any, groupIndex: number) => {
            const mapProduct = item.productQuota.map((pq: any) => {
              form2.setFieldValue(`limitQty-${pq.product.productId}`, pq.orderLimit);
              form2.setFieldValue(`specialPrice-${pq.product.productId}`, pq.discount);
              return {
                createdAt: pq.createdAt,
                discount: pq.discount,
                notDelete: pq.notDelete,
                orderLimit: pq.orderLimit,
                productQuotaGroupId: undefined,
                productQuotaId: undefined,
                quotaId: undefined,
                updatedAt: pq.updatedAt,
                productId: pq.productId,
                commonName: pq.product.commonName,
                marketPrice: pq.product.marketPrice,
                packSize: pq.product.packSize,
                productCodeNAV: pq.product.productCodeNAV,
                productGroup: pq.product.productGroup,
                productImage: pq.product.productImage,
                productName: pq.product.productName,
                saleUOM: pq.product.saleUOM,
                saleUOMTH: pq.product.saleUOMTH,
              };
            });
            item.shopTotalQuota.map((sq: any) => {
              form2.setFieldValue(`orderPerDay-${sq.customerCompanyId}`, sq.orderPerDay);
              form2.setFieldValue(`quotaReceive-${sq.customerCompanyId}`, sq.quotaReceive);
            });
            form2.setFieldsValue({
              products: mapProduct,
              stores: item.shopTotalQuota.map((sq: any) => {
                return {
                  ...sq,
                  productQuotaGroupId: undefined,
                  quotaId: undefined,
                  oldIsActive: sq.isActive,
                  isActive: true,
                  isChecked: false,
                };
              }),
              quotaId: undefined,
              [`productQuotaGroupId-${groupIndex}`]: undefined,
              summary: res.summary,
            });
          });
        }
      });
    } else if (form1.getFieldValue("quotaType") === "QUOTA_INDIVIDUAL") {
      await getProductQuotaProduct({
        quotaId,
        searchProduct: "",
      }).then((res) => {
        const mapValueForm2 = res?.data.map((item: any, groupIndex: number) => {
          form2.setFieldValue(`limitQty-${item.productId}`, item.orderLimit);
          form2.setFieldValue(`specialPrice-${item.productId}`, item.discount);
          const mapStore = item?.shopQuota?.map((sq: any) => {
            form2.setFieldValue(
              `orderPerDay-${item.productId}-${sq.customerCompanyId}`,
              sq.orderPerDay,
            );
            form2.setFieldValue(
              `quotaReceive-${item.productId}-${sq.customerCompanyId}`,
              sq.quotaReceive,
            );
            return {
              ...sq,
              shopQuotaId: undefined,
              isChecked: false,
              oldIsActive: sq.isActive,
              isActive: true,
            };
          });
          form2.setFieldsValue({
            quotaId: undefined,
            [`productQuotaId-${item.productId}`]: undefined,
          });
          return {
            ...item,
            storeList: mapStore,
          };
        });
        form2.setFieldsValue({
          products: mapValueForm2,
          summary: res.summary,
        });
      });
    }
    setLoading(false);
  };
  const fetchShopGroupList = async () => {
    const res = await getShopGroup({
      company,
      take: 0,
      page: 0,
    });
    const shopGroup = res.responseData.data.map((item: any) => ({
      label: item.customerGroupName,
      value: item.customerGroupName,
      key: item.customerGroupId,
    }));
    const allOption = {
      label: "กลุ่มลูกค้าทั้งหมด",
      value: "ALL",
      key: undefined,
    };
    setShopGroupData([allOption, ...shopGroup]);
  };
  const fetchZoneList = async () => {
    await zoneDatasource.getAllZoneByCompany(company).then((res) => {
      const mapZone = res.map((item: any) => ({
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneName,
      }));
      const allOption = {
        label: "เขตทั้งหมด",
        value: "ALL",
        key: undefined,
      };
      setZoneList([allOption, ...mapZone]);
    });
  };
  const PageTitle = () => {
    return (
      <PageTitleNested
        title={(isEditing && !isDuplicate ? "แก้ไข" : "สร้าง") + "โควตา"}
        showBack
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการโควตาสินค้า", path: "/productQuota" },
              ...(quotaId && !isDuplicate
                ? [{ text: "รายละเอียดโควตา", path: `/productQuota/detail/${quotaId}` }]
                : []),
              {
                text: quotaId && !isDuplicate ? "แก้ไขโควตา" : "สร้างโควตา",
                path: window.location.pathname,
              },
            ]}
          />
        }
        extra={
          form1.getFieldValue("quotaType") ? (
            <StepAntd current={current} items={getStepItems(form1.getFieldValue("quotaType"))} />
          ) : null
        }
        onBack={() => {
          Modal.confirm({
            title: (
              <Text level={3} fontWeight={700}>
                ยืนยันการกดย้อนกลับ
              </Text>
            ),
            content: (
              <>
                <Text color='error'>
                  หากกดย้อนกลับข้อมูลการกำหนดโควตาสินค้าและร้านค้าจะไม่ถูกบันทึกโปรดตรวจสอบให้แน่ใจก่อนยืนยัน
                </Text>
                <Divider style={{ margin: "8px 0px 0px" }} />
              </>
            ),
            icon: null,
            okButtonProps: { type: "primary" },
            cancelButtonProps: {},
            onOk: () => {
              navigate(-1);
            },
          });
        }}
      />
    );
  };
  const nextStep = async () => {
    if (current === 0) {
      try {
        const form1Values = await form1.validateFields();
        const dataForm1 = form1.getFieldsValue(true);
        form1.setFieldsValue({
          ...dataForm1,
          quotaTotalAmount: form1Values.quotaTotalAmount || undefined,
          conditionQuota: {
            limitQuantityOrder: form1Values.limitQuantityOrder,
            limitOrderDay: form1Values.limitOrderDay,
            limitOrderDayCondition: {
              allShop: form1Values.limitOrderPerDayType === "allShop",
              perShop: form1Values.limitOrderPerDayType === "perShop",
              orderAmount:
                form1Values.limitOrderPerDayType === "allShop" ? form1Values.countOrder : null,
            },
          },
        });
        setLoadingStep(true);
        setCurrent(1);
        setErrorMessage(null);
      } catch (e) {
        console.log("Step 0 validation failed (form)", e);
      }
    } else if (current === 1) {
      try {
        const form2Values = await form2.validateFields();
        const dataForm1 = form1.getFieldsValue(true);
        const dataForm2 = form2.getFieldsValue(true);
        if (
          dataForm2 === undefined ||
          dataForm2.products === undefined ||
          dataForm2.products.length === 0
        ) {
          setErrorMessage({
            success: true,
            step: 1,
            message:
              dataForm1.quotaType === "QUOTA_INDIVIDUAL"
                ? "โปรดกำหนดโควตาสินค้ารายร้าน"
                : dataForm1.quotaType === "QUOTA_GROUP"
                  ? "โปรดเพิ่มกลุ่มสินค้า"
                  : "โปรดเลือกสินค้าที่เข้าร่วม",
          });
        } else {
          let mapProduct: any = [];
          if (dataForm1.quotaType === "QUOTA_TOTAL") {
            mapProduct = dataForm2.products?.map((p: any) => {
              return {
                ...p,
                discount: Number(dataForm2[`specialPrice-${p.productId}`]) || null,
                orderLimit: Number(dataForm2[`limitQty-${p.productId}`]) || null,
              };
            });
            form2.setFieldValue("products", mapProduct);
            setLoadingStep(true);
            setCurrent(2);
          } else if (dataForm1.quotaType === "QUOTA_INDIVIDUAL") {
            mapProduct = dataForm2.products?.map((p: any) => {
              const mapStoresValue = (p.storeList || []).map((s: any) => {
                return {
                  ...s,
                  orderPerDay:
                    Number(dataForm2[`orderPerDay-${p.productId}-${s.customerCompanyId}`]) || null,
                  quotaReceive:
                    Number(dataForm2[`quotaReceive-${p.productId}-${s.customerCompanyId}`]) || null,
                };
              });
              return {
                ...p,
                discount: Number(dataForm2[`specialPrice-${p.productId}`]) || null,
                orderLimit: Number(dataForm2[`limitQty-${p.productId}`]) || null,
                storeList: mapStoresValue,
              };
            });
            form2.setFieldValue("products", mapProduct);
            setConfirmModal(true);
          } else if (dataForm1.quotaType === "QUOTA_GROUP") {
            const mapDataProduct = dataForm2.products?.map((prod: any, groupIndex: number) => {
              const mapProductList = prod.productList.map((p: any) => {
                return {
                  ...p,
                  discount: Number(dataForm2[`specialPrice-${p.productId}`]) || null,
                  orderLimit: Number(dataForm2[`limitQty-${p.productId}`]) || null,
                };
              });
              const mapStoresValue = (prod.storeList || []).map((s: any, i: number) => {
                const productQTDup: any = [];
                const productNon: any = [];
                s.isCanNotProductQuotaList.forEach((f) => productQTDup.push(f.productId));
                s.isCanNotOrderProductList.forEach((f) => productNon.push(f.productId));

                return {
                  ...s,
                  isDuplicate: productQTDup,
                  nonProductShop: productNon,
                  productQuotaGroupId: isEditing ? s.productQuotaGroupId : undefined,
                  quotaId: isEditing ? s.quotaId : undefined,
                  shopTotalQuotaId: isEditing ? s.shopTotalQuotaId : undefined,
                  orderPerDay:
                    Number(dataForm2[`orderPerDay-${s.customerCompanyId}-${prod.groupNo}`]) || null,
                  quotaReceive:
                    Number(dataForm2[`quotaReceive-${s.customerCompanyId}-${prod.groupNo}`]) ||
                    null,
                };
              });
              return {
                ...prod,
                productList: mapProductList,
                storeList: mapStoresValue,
              };
            });
            form2.setFieldsValue({
              products: mapDataProduct,
              quotaId: form1.getFieldValue("quotaId"),
            });
            setErrorMessage(null);
            setConfirmModal(true);
          }
        }
      } catch (e) {
        console.log("Step 1 validation failed (form)", e);
      }
    } else if (current === 2) {
      try {
        const form2Values = await form2.validateFields();
        const dataForm2 = form2.getFieldsValue(true);
        if (dataForm2.stores === undefined || dataForm2.stores.length === 0) {
          setErrorMessage({ success: true, step: 2, message: "โปรดเลือกร้านค้าที่เข้าร่วมโควตา" });
        } else {
          const mapDataShop = (dataForm2.stores as any)?.map((ps, index) => {
            const productQTDup: any = [];
            const productNon: any = [];
            ps.isCanNotProductQuotaList.forEach((f) => productQTDup.push(f.productId));
            ps.isCanNotOrderProductList.forEach((f) => productNon.push(f.productId));
            return {
              ...ps,
              orderPerDay: Number(
                dataForm2[`orderPerDay-${ps.customerCompanyId}`] || ps.orderPerDay || 0,
              ),
              quotaReceive: form1.getFieldValue("quotaTotalAmount") || 0,
              isDuplicate: productQTDup,
              nonProductShop: productNon,
              productQuotaGroupId: isEditing ? ps.productQuotaGroupId : undefined,
              quotaId: isEditing ? ps.quotaId : undefined,
              shopTotalQuotaId: isEditing ? ps.shopTotalQuotaId : undefined,
              customerGroup: ps.customerGroupName,
            };
          });
          form2.setFieldValue("stores", mapDataShop);
          setConfirmModal(true);
        }
      } catch (e) {
        console.log("Step 2 validation failed (form)", e);
      }
    }
  };
  const renderStep = () => {
    switch (current) {
      case 0: {
        return (
          <StepOneDup
            form1={form1}
            form2={form2}
            isEditing={isEditing}
            isDuplicate={isDuplicate}
            loadingStep={loadingStep}
            setLoadingStep={setLoadingStep}
          />
        );
      }
      case 1: {
        return (
          <StepTwoDup
            form1={form1}
            form2={form2}
            shopGroupData={shopGroupData}
            isEditing={isEditing}
            zoneList={zoneList}
            loadingStep={loadingStep}
            setLoadingStep={setLoadingStep}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        );
      }
      case 2:
        return (
          <StepThreeDup
            form1={form1}
            form2={form2}
            shopGroupData={shopGroupData}
            isEditing={isEditing}
            zoneList={zoneList}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            loadingStep={loadingStep}
            setLoadingStep={setLoadingStep}
          />
        );
      default:
        return null;
    }
  };
  const onSubmit = async () => {
    try {
      setSubmitting(true);
      const form1Values = await form1.getFieldsValue(true);
      const form2Values = await form2.getFieldsValue(true);
      const startDate =
        form1Values.startDate && form1Values.startTime
          ? dayjs(
              `${form1Values.startDate.format("YYYY-MM-DD")} ${form1Values.startTime.format("HH:mm")}:00`,
            ).toISOString()
          : null;

      const endDate =
        form1Values.endDate && form1Values.endTime
          ? dayjs(
              `${form1Values.endDate.format("YYYY-MM-DD")} ${form1Values.endTime.format("HH:mm")}:00`,
            ).toISOString()
          : null;

      const shopStatusChangedList: any[] = [];

      let payload: any = {
        quotaId: isEditing ? form1Values.quotaId : undefined,
        quotaName: form1Values.quotaName,
        company,
        startDate,
        endDate,
        updatedBy: `${firstname} ${lastname}`,
        role,
        quotaType: form1Values.quotaType,
        quotaTotalAmount: form1Values.quotaTotalAmount,
        conditionQuota: form1Values.conditionQuota,
        quotaShopPrice: form1Values.quotaShopPrice,
        quotaShopPriceCondition: form1Values.quotaShopPriceCondition,
        nonQuotaShopCondition: form1Values.nonQuotaShopCondition,
      };
      if (form1Values.quotaType === "QUOTA_TOTAL") {
        payload = {
          ...payload,
          productQuotaGroup: [
            {
              quotaId: isEditing ? form1Values.quotaId : undefined,
              productQuotaGroupId: isEditing
                ? form2.getFieldValue(`productQuotaGroupId-0`)
                : undefined,
              quotaReceive: form1Values.quotaTotalAmount || 0,
              quotaUsed: 0,
              productQuota: form2Values.products.map((prod) => {
                return {
                  groupNo: prod.groupNo,
                  productQuotaId: isEditing ? prod.productQuotaId : undefined,
                  productId: prod.productId,
                  quotaId: isEditing ? form1Values.quotaId : undefined,
                  productQuotaGroupId: isEditing ? prod.productQuotaGroupId : undefined,
                  discount: prod.discount,
                  orderLimit: prod.orderLimit,
                };
              }),
              shopTotalQuota: form2Values.stores
                .map(({ notDelete, ...shop }) => ({
                  ...shop,
                  quotaUsed: isEditing ? shop.quotaUsed || 0 : 0,
                  quotaId: isEditing ? form1Values.quotaId : undefined,
                  customerGroup: shop.customerGroupName,
                }))
                .filter((s) => s.isCanNotCreate === false),
            },
          ],
        };
        payload.productQuotaGroup.map((pq) => {
          pq.shopTotalQuota.forEach((sq) => {
            if (sq.oldIsActive !== sq.isActive) {
              pq.productQuota.forEach((p: any) => {
                shopStatusChangedList.push({
                  customerCompanyId: sq.customerCompanyId,
                  productQuotaId: p.productQuotaId,
                  isActive: sq.isActive,
                });
              });
            }
          });
        }); //map data for adjust status
      } else if (form1Values.quotaType === "QUOTA_GROUP") {
        payload = {
          ...payload,
          productQuotaGroup: form2Values.products.map((p: any, i: number) => {
            return {
              quotaId: isEditing ? form1Values.quotaId : undefined,
              productQuotaGroupId: isEditing
                ? form2.getFieldValue(`productQuotaGroupId-${p.groupNo}`)
                : undefined,
              quotaReceive: 0,
              quotaUsed: 0,
              groupNo: p.groupNo,
              productQuota: p.productList.map((prod) => {
                return {
                  productQuotaId: isEditing ? prod.productQuotaId || undefined : undefined,
                  productId: prod.productId,
                  quotaId: isEditing ? form1Values.quotaId : undefined,
                  productQuotaGroupId: isEditing
                    ? form2.getFieldValue(`productQuotaGroupId-${p.groupNo}`)
                    : undefined,
                  discount: prod.discount,
                  orderLimit: prod.orderLimit,
                };
              }),
              shopTotalQuota: p.storeList
                .map(({ notDelete, ...shop }) => ({
                  ...shop,
                  quotaId: isEditing ? form1Values.quotaId : undefined,
                  quotaUsed: isEditing ? shop.quotaUsed || 0 : 0,
                  customerGroup: shop.customerGroupName,
                }))
                .filter((s) => s.isCanNotCreate === false),
            };
          }),
        };

        payload.productQuotaGroup.map((pq) => {
          pq.shopTotalQuota.forEach((sq) => {
            if (sq.oldIsActive !== sq.isActive) {
              pq.productQuota.forEach((p: any) => {
                shopStatusChangedList.push({
                  customerCompanyId: sq.customerCompanyId,
                  productQuotaId: p.productQuotaId,
                  isActive: sq.isActive,
                });
              });
            }
          });
        }); //map data for adjust status
      } else if (form1Values.quotaType === "QUOTA_INDIVIDUAL") {
        const mapProduct = form2Values.products.map((p: any) => {
          return {
            ...p,
            quotaId: isEditing ? form1Values.quotaId : undefined,
            productQuotaId: isEditing ? p.productQuotaId : undefined,
            shopQuota: p.storeList
              .map((shop) => ({
                ...shop,
                quotaUsed: isEditing ? shop.quotaUsed : 0,
                shopQuotaId: isEditing ? shop.shopQuotaId : undefined,
                quotaId: isEditing ? form1Values.quotaId : undefined,
                customerGroup: shop.customerGroupName,
              }))
              .filter((s) => s.isCanNotCreate === false),
          };
        });
        payload = {
          ...payload,
          productQuota: mapProduct.filter((p) => p.shopQuota.length > 0),
        };

        payload.productQuota.map((pq) => {
          pq.shopQuota.forEach((sq) => {
            if (sq.oldIsActive !== sq.isActive) {
              shopStatusChangedList.push({
                customerCompanyId: sq.customerCompanyId,
                productQuotaId: pq.productQuotaId,
                isActive: sq.isActive,
              });
            }
          });
        }); //map data for adjust status
      }

      if (
        //quota group delete whole group or delete product in group or delete shop in group
        form2Values?.deleteGroups?.length > 0 ||
        form2Values?.deleteProductsInGroup?.length > 0 ||
        form2Values?.deleteShopsInGroup?.length > 0
      ) {
        const payloadDelete: any = {};
        form1Values.quotaType === "QUOTA_INDIVIDUAL"
          ? (payloadDelete.shopQuotaId = form2Values?.deleteShopsInGroup?.map((s) => s.shopQuotaId))
          : (payloadDelete.shopTotalQuotaId = form2Values?.deleteShopsInGroup?.map(
              (s) => s.shopTotalQuotaId,
            )),
          (payloadDelete.productQuotaGroupId = form2Values?.deleteGroups?.map(
            (p) => p.productList[0].productQuotaGroupId,
          )),
          (payloadDelete.productQuotaId = form2Values?.deleteProductsInGroup?.map(
            (g) => g.productQuotaId,
          )),
          (payloadDelete.updatedBy = `${firstname} ${lastname}`);
        payloadDelete.role = role;
        await deleteQuotaProductQuota(payloadDelete).then((res) => {
          if (res.success) {
            console.log("delete success");
          }
        });
      }

      shopStatusChangedList.length > 0 &&
        (await updateShopStatus({
          quotaId: form1Values.quotaId,
          updatedBy: `${firstname} ${lastname}`,
          productShopQuota: shopStatusChangedList,
        }).then((res) => {
          console.log("res updateShopStatus", res);
        }));
      if (form1Values.quotaType === "QUOTA_INDIVIDUAL") {
        if (isEditing) {
          await updateProductQuota(payload).then((res) => {
            if (res.success) {
              callBackIndex();
            }
          });
        } else {
          await createProductQuota(payload).then((res) => {
            if (res.success) {
              callBackIndex();
            }
          });
        }
      } else {
        if (isEditing) {
          await updateProductQuotaGroup(payload).then((res) => {
            if (res.success) {
              callBackIndex();
            }
          });
        } else {
          await updateQuotaGroupForDuplicate(payload).then((res) => {
            if (res.success) {
              callBackIndex();
            }
          });
        }
      }
    } catch (error) {
      console.error("Unexpected error in onSubmit:", error);
    } finally {
      setSubmitting(false);
    }
  };
  const callBackIndex = () => {
    navigate(`/productQuota`);
  };

  return (
    <OuterCardContainer>
      <CardContainer cutBottom>
        <PageTitle />
      </CardContainer>
      <Divider />
      <CardContainer cutTop>
        <>{renderStep()}</>
        <Divider />
        {!loadingStep && (
          <Row justify={[1, 2].includes(current) ? "space-between" : "end"}>
            <Col span={3}>
              <Button
                typeButton='border-primary'
                title='ย้อนกลับ'
                onClick={() => {
                  setCurrent(current - 1);
                  setLoadingStep(true);
                }}
                style={{ visibility: current > 0 ? "visible" : "hidden" }}
              />
            </Col>

            <Col span={3}>
              <Button
                typeButton='primary'
                title={(() => {
                  if (form1.getFieldValue("quotaType") === "QUOTA_TOTAL" && current === 2) {
                    return "บันทึก";
                  } else if (current === 1 && form1.getFieldValue("quotaType") !== "QUOTA_TOTAL") {
                    return "บันทึก";
                  } else {
                    return "ถัดไป";
                  }
                })()}
                onClick={nextStep}
              />
            </Col>
          </Row>
        )}
      </CardContainer>
      {confirmModal && (
        <ConfirmModal
          visible={confirmModal}
          loading={submitting}
          onConfirm={() => {
            onSubmit();
          }}
          onCancel={() => {
            setConfirmModal(false);
          }}
          title={`ต้องการ${!isEditing ? "บันทึก" : "แก้ไข"}โควตา`}
          desc='โปรดตรวจสอบรายละเอียดอีกครั้งก่อนการกดยืนยัน เพราะอาจส่งผลต่อข้อมูลร้านค้าในระบบ'
        />
      )}
    </OuterCardContainer>
  );
};
